export default __webpack_public_path__ + "static/media/loading1.d8ad4c1a.svg";